import IconButton from 'components/Shared/Buttons/IconButton';
import filterIcon from 'public/static/images/srp/Filter.svg';
import sortIcon from 'public/static/images/srp/Sort.svg';
import { colors, fonts } from 'components/styles/variables';
import classNames from 'classnames';

export type IconType = 'sort' | 'filter';

interface HeaderIconButtonProps {
  icon: IconType;
  onClick?: () => void;
}

export default function HeaderIconButton({ icon, onClick }: HeaderIconButtonProps): JSX.Element {
  return (
    <>
      <IconButton
        aria-label={`${icon}-button`}
        className="search-bar-header-icon-button"
        data-testid={`${icon}-button`}
        onClick={(): void => {
          onClick?.();
        }}
        style={{ backgroundColor: 'transparent', borderStyle: 'none' }}
      >
        <div className={`${icon}-button`}>
          <div className={classNames(`${icon}-icon`, 'icon')} />
          <div className="icon-text">{icon}</div>
        </div>
      </IconButton>
      <style jsx>{`
        .icon {
          height: 36px;
          width: 36px;
          background-size: cover;
        }

        .icon-text {
          font-family: ${fonts.default};
          font-style: normal;
          font-weight: 400;
          font-size: 10px;
          line-height: 12px;
          letter-spacing: 0.2px;
          color: ${colors.BLACK};
          text-transform: uppercase;
        }

        .sort-icon {
          background: url(${sortIcon});
        }

        .filter-icon {
          background: url(${filterIcon});
        }
      `}</style>
    </>
  );
}
